import { computed, defineComponent, h, toRefs } from 'vue';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';
import { ItemProps } from '@/ui/components/inspectionReport/types';
import { n } from '@/ui/i18n/i18n';
import { isNumberDefined } from '@/ui/helpers';
import { useItem } from '@/ui/components/inspectionReport/useItem';

export const Page = defineComponent<ItemProps>({
  name: 'Page',
  props: ['item'],
  setup(props) {
    const { resource, getSubItems, inspectionPagesCount } = useInspectionReport();
    const { item } = toRefs(props);
    const { title } = useItem(item);

    const hasMultiplePages = computed(() => inspectionPagesCount.value > 2);
    const hasPercentage = computed(() =>
      resource.value?.template?.display_score && isNumberDefined(props.item.percentage));

    return function render() {
      return h('div', [
        h('div', { class: 'flex items-end mb-2' }, [
          hasMultiplePages.value
            ? h('span', { class: 'flex-1 inspection-report__page-title' }, [title.value])
            : null,
          hasMultiplePages.value
            ? h('div', { class: 'font-semibold' }, [
              hasPercentage.value && n(props.item.percentage! / 100, 'scorePercentage'),
            ])
            : null,
        ]),
        h('div', { class: 'inspection-report__page-content' }, [
          ...(props.item.items ? getSubItems(props.item.items) : []),
        ]),
      ]);
    };
  },
});
